import { Injectable, Inject, Renderer2, RendererFactory2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SeoService {
  private renderer: Renderer2;
  private domain = environment.URLs.origin;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2,
    private router: Router
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.updateCanonicalLink();
      });
  }

  updateCanonicalLink(): void {
    // exclude any query parameters.
    let path = this.router.url.split("?")[0];

    // remove trailing slash if it's not the root path.
    if (path !== "/" && path.endsWith("/")) {
      path = path.slice(0, -1);
    }

    // Build the canonical URL dynamically.
    const canonicalUrl = `${this.domain}${path}`;
    let canonicalLink: HTMLLinkElement = this.document.querySelector(
      'link[rel="canonical"]'
    );

    if (canonicalLink) {
      // Update its href attribute.
      this.renderer.setAttribute(canonicalLink, "href", canonicalUrl);
    } else {
      // Create a new canonical tag if it doesn't exist.
      canonicalLink = this.renderer.createElement("link");
      this.renderer.setAttribute(canonicalLink, "rel", "canonical");
      this.renderer.setAttribute(canonicalLink, "href", canonicalUrl);
      this.renderer.appendChild(this.document.head, canonicalLink);
    }
  }
}
